module.exports = __webpack_public_path__ + "img/Nikolajs-Precenieks.71d400cd.jpg";